export const SCORE_TYPES = [
    { value: "INITIAL", key: "initialScore" },
    { value: "GIFT", key: "giftScore" },
    { value: "OTHER", key: "otherScore" },
];
